export default __webpack_public_path__ + "4224176dc1dd65669e98154f15e48a23.png";